<template>
  <van-popup :value="value" position="center" class="receive-input-popup" @click-overlay="close">
    <div class="popup-body" v-if="value">
      <div class="inviter">
        <img class="avatar" :src="inviter.avatar" alt="" />
        <div class="inviter-info">
          <span class="name">您的好友，{{ inviter.nickname || '好友' }}</span>
          <span class="desc">邀你组搭子一起运动</span>
        </div>
      </div>
      <div class="pop-logo-container">
        <div class="line"></div>
        <img class="pop-logo"
          src="https://gympic.gymcity.com.cn/uploads-add/202609/2026-09-29-zxg-invite-activity-btm-logo" alt="">
        <div class="line"></div>
      </div>
      <div class="divider-title">
        <span class="text">填写信息，和朋友一起练</span>
      </div>
      <div class="input-item">
        <span class="label">手机号</span>
        <input class="input" type="number" maxlength="11" v-model="phone" placeholder="请输入手机号" />
      </div>
      <div class="code-row">
        <div class="input-item code-input">
          <span class="label">验证码</span>
          <input class="input" type="number" maxlength="6" v-model="smsCode" placeholder="请输入验证码" />
        </div>
        <span class="send-btn" @click="onSendCode">{{
          codeTime ? codeTime + 'S' : '获取验证码'
        }}</span>
      </div>
      <div class="agreement-row" v-if="agreements.length">
        <div class="checkbox" :class="{ checked: allAgreed }" @click="toggleAgreeAll"></div>
        <div class="agreement-text">
          <span class="prefix">已阅读并同意</span>
          <template v-for="(item, idx) in agreements">
            <span :key="item.code" class="agreement-title" @click="onViewAgreement(item)">《{{ item.title }}》</span><span
              :key="item.code + '_sep'" class="separator" v-if="idx < agreements.length - 1">、</span>
          </template>
        </div>
      </div>
      <div class="confirm-btn" @click="onConfirm">确认领取</div>
      <div class="cancel-btn" @click="close">取消</div>
    </div>
  </van-popup>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    // 转介人信息 { nickname, avatar }
    inviter: {
      type: Object,
      default: () => ({})
    },
    // 场景下发的协议列表 [{ code, title, content }]
    agreements: {
      type: Array,
      default: () => []
    },
    // 老用户（转介人）ID，用于埋点携带
    userId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      phone: '',
      smsCode: '',
      codeTime: 0, // 验证码倒计时
      timer: null,
      agreedCodes: [] // 已勾选的协议 code
    }
  },
  computed: {
    allAgreed() {
      if (!this.agreements.length) {
        return false
      }
      return this.agreements.every((a) => this.agreedCodes.indexOf(a.code) > -1)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
    reset() {
      this.phone = ''
      this.smsCode = ''
      this.codeTime = 0
      this.agreedCodes = []
      clearInterval(this.timer)
    },
    // 一键勾选/取消所有协议
    toggleAgreeAll() {
      if (this.allAgreed) {
        this.agreedCodes = []
      } else {
        this.agreedCodes = this.agreements.map((a) => a.code)
      }
    },
    // 点击协议标题跳详情页（只展示自己那一份内容，列表接口已带 content）
    onViewAgreement(item) {
      // prettier-ignore
      const url = '/zx-referral/covenant-detail?code=' + encodeURIComponent(item.code)
      if (this.$betterwe.isApp && this.$betterwe.isApp()) {
        this.$router.push(url)
      } else {
        window.location.href = url
      }
    },
    // 发送领卡验证码
    onSendCode() {
      if (this.codeTime > 0) {
        return
      }
      if (!this.checkPhone()) {
        return
      }
      this.$http
        .postArena('/api/referral/sms/send', { phone: this.phone })
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.$toast('验证码已发送')
            const interval = (res.data && res.data.interval_seconds) || 60
            this.startInterval(interval)
          } else {
            this.$dialog.alert({ message: res.msg })
          }
        })
        .catch(() => {
          this.$dialog.alert({ message: '网络异常，请稍后重试' })
        })
    },
    startInterval(seconds) {
      this.codeTime = seconds
      this.timer = setInterval(() => {
        this.codeTime--
        if (this.codeTime <= 0) {
          clearInterval(this.timer)
        }
      }, 1000)
    },
    checkPhone() {
      if (!this.phone.length) {
        this.$toast('请输入手机号')
        return false
      }
      if (this.phone.length !== 11) {
        this.$toast('请检查手机号格式')
        return false
      }
      return true
    },
    onConfirm() {
      // 「注册」按钮点击埋点
      this.$http.bindH5UMA('zxg_referral_202610_register_btn_click', this.userId)
      if (!this.checkPhone()) {
        return
      }
      if (!this.smsCode) {
        this.$toast('请输入验证码')
        return
      }
      if (!this.allAgreed) {
        this.$toast('请先阅读并同意协议')
        return
      }
      this.$emit('confirm', {
        phone: this.phone,
        smsCode: this.smsCode,
        agreedProtocols: this.agreedCodes.slice()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.receive-input-popup {
  border-radius: 12px;
}

.popup-body {
  width: 343px;
  background: #fff;
  border-radius: 12px;
  padding: 20px 20px 24px;
  box-sizing: border-box;
}

.inviter {
  display: flex;
  width: 100%;
  margin-bottom: 20px;

  .avatar {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
  }

  .inviter-info {
    display: flex;
    flex-direction: column;
    margin: 7px 0 5px 12px;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    .name {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 16px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .desc {
      margin-top: 6px;
      font-size: 12px;
      font-family: MiSans-Normal, MiSans;
      color: rgba(0, 0, 0, 0.6);
      line-height: 18px;
    }
  }
}

.pop-logo-container {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 6px;
  .line {
    width: 61px;
    height: 1px;
    background-color: #F1F1F1;
  }

  .pop-logo {
    width: 147px;
    height: 14px;
    filter: brightness(0) invert(60%);
  }
}

.divider-title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 14px 0 15px;

  .line {
    width: 67px;
    height: 1px;
    background: #f1f1f1;
  }

  .text {
    margin: 0 9px;
    font-size: 11px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.3);
    line-height: 16px;
  }
}

.input-item {
  display: flex;
  align-items: center;
  width: 303px;
  background: rgba(247, 247, 247, 1);
  border: 1px solid rgba(241, 241, 241, 1);
  border-radius: 8px;
  padding: 7px 15px 8px;
  box-sizing: border-box;
  margin: 12px auto 0;

  .label {
    font-size: 14px;
    letter-spacing: -0.39px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 20px;
    flex-shrink: 0;
  }

  .input {
    flex: 1;
    margin-left: 12px;
    border: 0;
    outline: none;
    background: transparent;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #000;
    line-height: 20px;

    &::placeholder {
      color: rgba(0, 0, 0, 0.3);
    }
  }
}

.code-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 303px;
  margin: 16px auto 0;

  .code-input {
    width: 213px;
    margin: 0;
  }

  .send-btn {
    font-size: 13px;
    letter-spacing: -0.36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ff6419;
    line-height: 18px;
  }
}

.confirm-btn {
  background: rgba(5, 11, 39, 1);
  border-radius: 24px;
  padding: 12px 0 11px;
  margin-top: 20px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #fff;
  text-align: center;
  line-height: 25px;

  &:active {
    opacity: 0.6;
  }
}

.agreement-row {
  display: flex;
  align-items: flex-start;
  margin-top: 16px;
  padding: 0 6px;

  .checkbox {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 1.5px solid #d8d8d8;
    box-sizing: border-box;
    margin-top: 2px;
    flex-shrink: 0;
    position: relative;
    background: #fff;

    &.checked {
      border-color: rgba(255, 100, 25, 1);
      background: rgba(255, 100, 25, 1);

      &::after {
        content: '';
        position: absolute;
        left: 4px;
        top: 1px;
        width: 4px;
        height: 8px;
        border: solid #fff;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
      }
    }
  }

  .agreement-text {
    flex: 1;
    margin-left: 8px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.6);
    line-height: 18px;

    .prefix {
      margin-right: 2px;
    }

    .agreement-title {
      color: #4a7bf7;
      font-weight: 500;
    }

    .separator {
      margin: 0 2px;
    }
  }
}

.cancel-btn {
  margin-top: 21px;
  font-size: 18px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #050b27;
  text-align: center;
  line-height: 25px;
}
</style>
